import { render } from "./anc_profile_editor.vue?vue&type=template&id=af1d5352&scoped=true"
import script from "./anc_profile_editor.vue?vue&type=script&lang=js"
export * from "./anc_profile_editor.vue?vue&type=script&lang=js"

import "./anc_profile_editor.vue?vue&type=style&index=0&id=af1d5352&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1d5352"]])

export default __exports__